import { Link } from "react-router-dom";
import { Sparkles, Wallet, Rocket, CheckCircle2 } from "lucide-react";

/**
 * Onboarding49Card — animated START YOUR HEYLPMATE JOURNEY CTA.
 * Shown on every listing page and the customer dashboard.
 * Tapping opens /pay-upi with purpose=onboarding_49 → confirmed txn credits 5 credits.
 */
export default function Onboarding49Card({ compact = false }) {
  if (compact) {
    return (
      <Link
        to="/pay-upi?amount=49&purpose=onboarding_49"
        data-testid="onboarding-49-cta"
        className="group block rounded-2xl overflow-hidden border-2 relative animate-pulse-glow"
        style={{
          borderColor: "#F45118",
          background: "linear-gradient(135deg,#FFF3EA 0%,#FFE8D5 60%,#FFDDC0 100%)",
        }}>
        <div className="flex items-center justify-between p-3 gap-3">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-full grid place-items-center text-white shadow-lg"
                 style={{ background: "linear-gradient(135deg,#F45118,#DC2626)" }}>
              <Sparkles className="w-4 h-4" />
            </div>
            <div>
              <div className="font-display text-sm font-bold" style={{ color: "#00604A" }}>
                Start your HeylpMate journey · <span style={{ color: "#F45118" }}>₹49</span>
              </div>
              <div className="text-[10px]" style={{ color: "#667085" }}>Pay ₹49 → get 5 credits → unlock 2 listings instantly</div>
            </div>
          </div>
          <span className="text-xs font-bold rounded-full px-3 py-1.5 text-white shadow"
                style={{ background: "#F45118" }}>Start →</span>
        </div>
      </Link>
    );
  }
  return (
    <div className="rounded-3xl overflow-hidden border-2 p-6 md:p-7 relative"
         style={{ borderColor: "#F45118",
                  background: "linear-gradient(135deg,#FFF3EA 0%,#FFE8D5 60%,#FFDDC0 100%)" }}
         data-testid="onboarding-49-card">
      <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full opacity-20"
           style={{ background: "radial-gradient(circle,#F45118 0%,transparent 70%)" }} />
      <div className="relative">
        <div className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white shadow"
             style={{ background: "linear-gradient(90deg,#F45118,#DC2626)" }}>
          <Sparkles className="w-3 h-3" /> Limited-time starter
        </div>
        <h3 className="mt-3 font-display text-3xl md:text-4xl font-bold leading-tight" style={{ color: "#00604A" }}>
          Start your HeylpMate journey — <span style={{ color: "#F45118" }}>₹49</span>
        </h3>
        <p className="mt-1 text-sm" style={{ color: "#667085" }}>Pay once. Unlock real people. Get deals done.</p>

        <div className="mt-5 grid md:grid-cols-3 gap-3">
          <div className="rounded-2xl bg-white/70 p-3">
            <div className="inline-flex items-center gap-1.5 text-xs font-bold" style={{ color: "#F45118" }}>
              <Wallet className="w-4 h-4" /> Step 1
            </div>
            <div className="mt-1 font-display text-lg" style={{ color: "#00604A" }}>Pay ₹49 via UPI</div>
            <div className="text-[11px]" style={{ color: "#667085" }}>Scan the HeylpMate QR — takes 5 seconds.</div>
          </div>
          <div className="rounded-2xl bg-white/70 p-3">
            <div className="inline-flex items-center gap-1.5 text-xs font-bold" style={{ color: "#F45118" }}>
              <Rocket className="w-4 h-4" /> Step 2
            </div>
            <div className="mt-1 font-display text-lg" style={{ color: "#00604A" }}>Get 5 credits</div>
            <div className="text-[11px]" style={{ color: "#667085" }}>Instantly loaded. Every unlock costs 2 credits.</div>
          </div>
          <div className="rounded-2xl bg-white/70 p-3">
            <div className="inline-flex items-center gap-1.5 text-xs font-bold" style={{ color: "#F45118" }}>
              <CheckCircle2 className="w-4 h-4" /> Step 3
            </div>
            <div className="mt-1 font-display text-lg" style={{ color: "#00604A" }}>Get deal done</div>
            <div className="text-[11px]" style={{ color: "#667085" }}>2 listings, 1 WhatsApp connect, 0 brokerage.</div>
          </div>
        </div>

        <Link to="/pay-upi?amount=49&purpose=onboarding_49" data-testid="onboarding-49-cta-btn"
              className="mt-5 inline-flex items-center gap-2 rounded-full px-6 py-3 text-white font-bold shadow-lg hover:opacity-95 transition"
              style={{ background: "#F45118" }}>
          Start for ₹49 <Rocket className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
